var MDB = window.MDB || {};
MDB.ContentEditor = MDB.ContentEditor || {};

(function ($) {
    $.extend(MDB.ContentEditor, {
        boot: function (form, configEditorUrl) {
            form = $(form);
           
            var contentConfig = form.find('.content-config');
            var contentTypeSelector = form.find('[name$="ContentType"]');
           
            form.find('[name$="Channels"]').kendoMultiSelect();
           
            contentTypeSelector.on('change', function () {
                var contentType = this.value;
               
                $.ajax({
                    url: configEditorUrl + '?contentType=' + contentType,
                    success: function (data) {
                        contentConfig.html(data);
                    }
                });
            });

            var labelSelector = form.find('[name$="Labels"]');
           
            var kMultiSelect = labelSelector.kendoMultiSelect({
                dataTextField: 'text',
                dataValueField: 'value',
                placeholder: 'Labels'
            }).data('kendoMultiSelect');


            var multiSelectInput = labelSelector.siblings().find('input');

            multiSelectInput.on('keydown change', function (e) {
                var isKeyDown = e.type === 'keydown';

                //Tab/Enter/Spacebar
                if (!isKeyDown || (e.which === 9 || e.which === 13 || e.which === 32)) {
                    var value = this.value.replace(' ', '');

                    var backgroundColor = '#FFFFFF';

                    if (value.length > 0 && value.length <= 25) {
                        e.preventDefault();

                        var values = kMultiSelect.value().slice();
                       
                        if (values.indexOf(value) !== -1) {
                            return;
                        }
                       
                        var dataSource = kMultiSelect.dataSource;
                        var data = dataSource.data();
                       
                        if (!_.find(data, {value: value})){
                            data.push({ text: value, value: value });
                            dataSource.data(data);
                        }

                        dataSource.filter({});
                        values.push(value);
                       
                        kMultiSelect.value(values);
                    } else {
                        if (isKeyDown && !!value) {
                            backgroundColor = '#d73925';
                        }
                    }

                    labelSelector.siblings('.k-multiselect-wrap.k-floatwrap').css({
                        'background-color': backgroundColor
                    });
                }
            });
        }
    });
})(jQuery);